"use client";

import dynamic from "next/dynamic";
import { SpinnerCurrent } from "@/components/atoms/SpinnerCurrent/SpinnerCurrent";

// Ciało ankiety jest interaktywne (formularz, kalendarz timeslotów) i NIE wymaga
// SEO — ładujemy je tylko po stronie klienta (ssr:false). Eliminuje to ryzyka SSR
// (FullCalendar, react-select, react-datepicker) i zapewnia działanie hooków
// next/navigation. Metadane SEO/OG renderuje serwer (generateMetadata strony).
const PollTemplate = dynamic(
  () =>
    import("@/components/templates/PollTemplate/HomeTemplate").then(
      (m) => m.PollTemplate,
    ),
  { ssr: false, loading: () => <SpinnerCurrent /> },
);

export default function PollClient({ pollId }: { pollId: string }) {
  return <PollTemplate pollId={pollId} />;
}
